(function($j) {
    $j(function() {
        var patternsMsg = 'Please follow the password requirements listed.';
        var requiredMsg = 'This is a required field. ' + patternsMsg;
        var verifyPassword = 'This must match the password.';

        var NO_MORE_THAN_THREE_CONSECUTIVE_CHARS = /^(?!.*(.)\1\1\1).*$/;
        var ONE_NUMBER = /(?=.*\d).*/;
        var ONE_UPPERCASE_LETTER_ONE_LOWERCASE_LETTER = /(?=.*[A-Z])(?=.*[a-z]).*/;
        var ONE_SPECIAL_CHARACTER = /[\W_]/;
        var passwordInput = $j('#password')[0];
        var confirmPasswordInput = $j('#confirmPassword')[0];
        var resetPasswordForm = $j('#caSignInResetPasswordForm');
        var resetPasswordButton = $j('#resetPasswordButton');
        var passwordPatternsDiv = $j('.password-patterns');
        var userEmail = $j('#userEmail').val();
        var userLogin = $j('#userLogin').val();
        var restrictedPhrases = (userEmail && userLogin) ? [userEmail, userLogin] : [];
        var minMaxLengthDiv = $j('.min-max-length');
        var minLengthValue = minMaxLengthDiv.data('minlength');
        var MIN_MAX_LENGTH = new RegExp('^.{' + minLengthValue + ',250}$');
        var hasNoLoginEmailMatch = function(value) {
            return restrictedPhrases.length ? $j.inArray(value, restrictedPhrases) : false;
        }

        var passwordMatch = function(password, confirmPassword) {
            return confirmPassword.toString().toLowerCase() === password.toLowerCase();
        };

        var validatePasswordPattern = function(validationPattern, className) {
            validationPattern ?
                $j(className).removeClass('ca-ui-text-medium-gray').addClass('ca-ui-text-success') :
                $j(className).removeClass('ca-ui-text-success').addClass('ca-ui-text-medium-gray');
        };

        if (!resetPasswordForm.length) return; // for sign-in pages without this form

        resetPasswordForm.validateForm({
            onkeyup: function(element, event) {
                passwordPatternsDiv.removeClass('hide');
                var sanitizedPassword = $j.trim(passwordInput.value.toString());
                var sanitizedConfirmPassword = $j.trim(confirmPasswordInput.value.toString());
                var minMaxLength = MIN_MAX_LENGTH.test(sanitizedPassword);
                var hasOneNumber = ONE_NUMBER.test(sanitizedPassword);
                var doesNotHaveThreeConsecutiveChars = NO_MORE_THAN_THREE_CONSECUTIVE_CHARS.test(sanitizedPassword) && sanitizedPassword;
                var hasUpperAndLowerCaseCharacters = ONE_UPPERCASE_LETTER_ONE_LOWERCASE_LETTER.test(sanitizedPassword);
                var hasOneSpecialCharacter = ONE_SPECIAL_CHARACTER.test(sanitizedPassword);
                var isConfirmPasswordMatching = sanitizedPassword && sanitizedConfirmPassword &&
                    passwordMatch(sanitizedConfirmPassword, sanitizedPassword);

                validatePasswordPattern(minMaxLength, '.min-max-length');
                validatePasswordPattern(hasUpperAndLowerCaseCharacters, '.mix-upper-lower');
                validatePasswordPattern(hasOneNumber, '.has-one-number');
                validatePasswordPattern(doesNotHaveThreeConsecutiveChars, '.does-not-have-consec-chars');
                validatePasswordPattern(hasNoLoginEmailMatch(passwordInput.value) && passwordInput.value.toString().length, '.has-no-login-email-match');
                validatePasswordPattern(isConfirmPasswordMatching, '.confirming-pass-match');
                validatePasswordPattern(hasOneSpecialCharacter, '.special-character');

                !isConfirmPasswordMatching ? event.preventDefault() : $j(element).valid();
            },
            rules: {
                password: {
                    required: true,
                    passwordPattern: true
                },
                confirmPassword: {
                    required: true,
                    equalTo: '#password'
                }
            },
            messages: {
                password: {
                    required: requiredMsg,
                    passwordPattern: patternsMsg
                },
                confirmPassword: {
                    equalTo: verifyPassword
                }
            },
        });

        $j.validator.addMethod("passwordPattern", function(value) {
            return MIN_MAX_LENGTH.test(value) &&
                NO_MORE_THAN_THREE_CONSECUTIVE_CHARS.test(value) &&
                ONE_NUMBER.test(value) &&
                ONE_UPPERCASE_LETTER_ONE_LOWERCASE_LETTER.test(value) &&
                hasNoLoginEmailMatch(value);
        });

        resetPasswordForm.on('submit', function() {
            passwordPatternsDiv.removeClass('hide');
            var isFormValid = resetPasswordForm.valid();

            if (isFormValid) {
                if (resetPasswordForm.data('caUi-globalError')) {
                    resetPasswordForm.globalError('destroy');
                }

                resetPasswordButton
                    .buttonState()
                    .buttonState('loading');

                $j.post(
                        '/reset-password/process', {
                            pass1: $j('#password').val(),
                            pass2: $j('#confirmPassword').val(),
                            h: $j('#reset-password-token').val(),
                            passFormToken: $j('#reset_pass_form_token').val()
                        }
                    )
                    .done(function(data) {
                        if (data.status === 1) {
                            window.location.href = '/';
                        } else {
                            resetPasswordButton.buttonState('default');

                            if (data.message) {
                                resetPasswordForm.globalError({
                                    errorMessage: data.message
                                });
                            } else {
                                resetPasswordForm.globalError();
                            }
                        }
                    })
                    .fail(function() {
                        resetPasswordButton.buttonState('default');
                        resetPasswordForm.globalError();
                    });
            }
        });
    });
})(jQuery);
